import { Skeleton, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { TabMainTitle } from "../../Components/View/Typography/title";
import GeneralTable from "../../Components/View/Table/TableGeneral";
import { ApiUrls } from "../../Components/Utils/globalVariables";
import useFetch from "../../Service/Hooks/useFetch";
 
export default function VisaResult({ code }) {

    const [{response, isLoading, error}, doFetch] = useFetch(ApiUrls.GetVisaOptions, "get", true)

    useEffect(() => {
        if(code) {
            doFetch({id: code})
        }
    }, [code])
    
    if(code && isLoading) {
        return (
            <Stack spacing={3}>
                <GeneralTable 
                    data={response}
                    section="visaOption"
                />
            </Stack>
        )
    } else if(!isLoading && code) {
        return (
            <Skeleton sx={{width: "100%", height: "160px", my: 3}} variant="rounded" />
        )
    } 
}
